import React from 'react';
import classes from './StarRating.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ratingHelpers } from '@/utils/helpers';

const StarRating = ({ stars, ...props }) => {
  const clampedStars = Math.min(Math.max(Math.ceil(stars) || 0, 0), ratingHelpers.MAX_RATING);
  const fullStars = [...new Array(clampedStars)];
  const emptyStars = [...new Array(ratingHelpers.MAX_RATING - clampedStars)];
  return (
    <>
      {stars > ratingHelpers.EMPTY_RATING && (
        <div className={classes.starRating}>
          <ul className="list-inline list-unstyled">
            {fullStars.map((star, index) => {
              return (
                <li key={index} className="list-inline-item">
                  <FontAwesomeIcon icon={['fas', 'star']} />
                </li>
              );
            })}
            {emptyStars.map((star, index) => {
              return (
                <li key={fullStars.length + index} className="list-inline-item">
                  <FontAwesomeIcon icon={['far', 'star']} />
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </>
  );
};

export default StarRating;
